// Functions that handle the connection to the server.
// Do either a GET or POST request to the server.
const SERVER_URL = 'https://us-central1-stellar-ether-198321.cloudfunctions.net/players';
// Debug setting of whether to save or not.
// TODO: Make an easier way to set this.
const shouldSaveMoves = true;
export async function saveMoves(playeVisualInfo, level, moves) {
    if (!shouldSaveMoves) {
        return;
    }
    const data = Object.assign({
        level: level,
        moves: moves,
    }, playeVisualInfo);
    await fetch(SERVER_URL, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    });
}
export async function fetchSavedMoves(level) {
    const response = await fetch(`${SERVER_URL}?level=${level}`);
    return await response.json();
}
export async function fetchAllPlayers() {
    const response = await fetch(`${SERVER_URL}/all`);
    return await response.json();
}
